module.exports = __webpack_public_path__ + "static/img/goat.96cb2e5c.png";